// stores/checklist-detail-store.js
import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/config/api";
import { withShioriAccessContext } from "@/api/shiori-access-context.js";

export const useChecklistDetailStore = defineStore("checklistDetail", {
  state: () => ({
    checklistDetails: [],
    loadedShioriId: null,
    isLoading: false,
    error: null,
  }),
  getters: {
    // カテゴリごとにグループ化
    groupedByCategory: (state) => {
      const grouped = {};
      state.checklistDetails.forEach((item) => {
        const category = item.CATEGORY_NAME || "その他";
        if (!grouped[category]) {
          grouped[category] = [];
        }
        grouped[category].push(item);
      });
      return grouped;
    },
    // カテゴリリストを取得
    categories: (state) => {
      const categorySet = new Set();
      state.checklistDetails.forEach((item) => {
        categorySet.add(item.CATEGORY_NAME || "その他");
      });
      return Array.from(categorySet);
    },
  },
  actions: {
    async fetchChecklistDetails(shioriId) {
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get(
          `${API_URL}/checklist_detail/?shiori_id=${shioriId}`,
        );
        this.checklistDetails = response.data;
        this.loadedShioriId = shioriId;
        console.log(
          "[ChecklistDetailStore] チェックリスト取得:",
          response.data,
        );
      } catch (err) {
        this.error = err;
        console.error("チェックリスト取得エラー:", err);
      } finally {
        this.isLoading = false;
      }
    },
    async createChecklistDetail(data) {
      this.isLoading = true;
      this.error = null;
      try {
        const { shiori_id, category_name, item_name } = data;
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${API_URL}/checklist_detail/?shiori_id=${shiori_id}&category_name=${encodeURIComponent(
            category_name,
          )}&item_name=${encodeURIComponent(item_name)}`,
          {},
          withShioriAccessContext(shiori_id, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        );
        // 作成成功後、リストを再取得
        await this.fetchChecklistDetails(shiori_id);
        return response.data;
      } catch (err) {
        this.error = err;
        console.error("チェックリスト作成エラー:", err);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
    clearShioriChecklistDetails(shioriId) {
      if (String(this.loadedShioriId) !== String(shioriId)) return;
      this.checklistDetails = [];
      this.loadedShioriId = null;
      this.error = null;
    },
  },
});
